
import React from 'react';
import ReactDOM from 'react-dom/client';
import document from 'global/document';
import {Provider} from 'react-redux';
import {browserHistory, Router, Route} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';
import store from './store';
import App from './app';
import {buildAppRoutes} from './utils/routes';

import '@aws-amplify/ui-react/styles.css'
import { Amplify } from 'aws-amplify';
import { config } from './auth/config';

const history = syncHistoryWithStore(browserHistory, store);

const appRoute = buildAppRoutes(App);
Amplify.configure(config);

const Root = () => (
    <Provider store={store}>
      <Router history={history}>
        <Route path="/" component={App}>
          {appRoute}
        </Route>
      </Router>
    </Provider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Root />);